<template>
    <div class="my_model">
        <div class="model_container">
            <el-table
                :data="userModelList"
                :header-cell-style="tableHeaderStyle"
                :cell-style="setCellStyle"
                :row-class-name="tableRowClassName"
                style="width: 100%">
                <el-table-column prop="name" label="模型名称">
                    <template slot-scope="scope" >
                        <span style="color: #606060; font-size: 1.09rem; cursor: pointer;" @click="goModelDetail(scope.row)">{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="url" label="缩略图">
                    <template slot-scope="scope">
                        <img :src="scope.row.thumbnail" style="border-radius: 0.3rem; width: 5.25rem; height: 4.94rem; cursor: pointer;" @click="goModelDetail(scope.row)">
                    </template>
                </el-table-column>
                <el-table-column prop="isPublic" label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isPublic" type="success">公开</el-tag>
                        <el-tag v-else type="info">私有</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="displaySize" label="大小">
                    <template slot-scope="scope">
                        <span style="color: #999999; font-size: 0.85rem;">{{ scope.row.displaySize }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="modelFormat" label="格式">
                    <template slot-scope="scope">
                        <span style="color: #999999; font-size: 0.85rem;">{{ scope.row.modelFormat }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="modelDimension" label="尺寸(m³)">
                    <template slot-scope="scope">
                        <span style="color: #999999; font-size: 0.85rem;">{{ scope.row.modelLong }} * {{ scope.row.modelWide }} * {{ scope.row.modelHeight }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作"  width="240px">
                    <template slot-scope="scope">
                        <i class="el-icon-edit"
                             @click="editModel(scope.row)" title="编辑"
                             style="font-size: 24px; padding-left: 1rem;">
                        </i>
                        <i class="el-icon-delete"
                             @click="deleteModel(scope.row.id)" title="删除"
                             style="font-size: 24px; padding-left: 1rem;">
                        </i>
                        <i class="el-icon-share"
                             @click="shareModel(scope.row)" title="分享"
                             style="font-size: 24px; padding-left: 1rem;">
                        </i>
                        <i class="el-icon-circle-close" v-if="scope.row.share"
                             @click="cancelShareModel(scope.row)" title="取消分享"
                             style="font-size: 24px; padding-left: 1rem;">
                        </i>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <div class="title">

            </div>
            <div class="model_lists">
                <model-show-list v-for="(item,index) in modelList" :key="index" :model="item"></model-show-list>
            </div> -->
        </div>
        <div class="model_page">
                <el-pagination
                    background
                    :current-page="currentElPage"
                    :total="totalPages"
                    :page-size="size"
                    @current-change="currentChange"
                    :hide-on-single-page="value"
                    layout="prev, pager, next"
                    @size-change="handleSizeChange"
                    >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import ModelShowList from '../../../components/modelShowList/index.vue'
import { getUerModelList, getUserModel, getModelById, deleteUserModel, createPrivateModelCode } from '../../../util/index'
export default {
    data() {
        return {
            modelList:[
                {
                    order:1,
                    name:'磁粉探伤机',
                    url:require('../../../assets/image/资源 230.png'),
                    size:'4.40MB',
                    format:'FBX',
                    scale:'0.956*0.756*1.414',
                    operate:''
                },
                {
                    order:2,
                    name:'磁粉探伤机',
                    url:require('../../../assets/image/资源 230.png'),
                    size:'4.40MB',
                    format:'FBX',
                    scale:'0.956*0.756*1.414',
                    operate:''
                },
                {
                    order:3,
                    name:'磁粉探伤机',
                    url:require('../../../assets/image/资源 230.png'),
                    size:'4.40MB',
                    format:'FBX',
                    scale:'0.956*0.756*1.414',
                    operate:''
                },
            ],
            userModelLists:[],
            userModelList:[],
            totalModels:0,
            totalPages: 0,
            size: 10,
            value: false,  //隐藏分页
            currentElPage: 1,  //当前页
        }
    },
    methods:{
        tableRowClassName(row, rowIndex){
            if ((row.rowIndex+1) % 2 === 1){
                return 'deep'
            }else if((row.rowIndex+1) % 2 === 0){
                return 'shallow'
            }
        },
        // 表头圆角
        tableHeaderStyle({row, column, rowIndex, columnIndex}){
            let extra = {}
            if (rowIndex === 0 && columnIndex === 0) {
                extra = {
                    'background-color':'red',
                    'border-radius':'0.56rem 0 0 0.56rem'
                }
            } else if(rowIndex === 0 && columnIndex === 6){
                extra = {
                    'background-color':'red',
                    'border-radius':'0 0.56rem 0.56rem 0'
                }
            }
            const styleResult = Object.assign({}, extra, {
                'background-color':'#C9C9C9',
            })
            return styleResult
        },
        // 表格内容圆角
        setCellStyle({row, column, rowIndex, columnIndex}){
            let extra = {}
            if (columnIndex === 0){
                extra = {
                    'border-radius':'0.56rem 0 0 0.56rem'
                }
            } else if(columnIndex === 6){
                extra = {
                    'border-radius':'0 0.56rem 0.56rem 0'
                }
            }
            const styleResult = Object.assign({}, extra, {
                
            })
            return styleResult
        },
        currentChange(page){
            this.currentElPage = page
            this.getModelList()
        },
        handleSizeChange(val){
            this.size = val
            this.getModelList()
        },
        getModelList(){
            let token = window.localStorage.getItem('userToken')
            let obj = {
                current: this.currentElPage,
                size: this.size
            }
            getUserModel(obj, token).then(res=>{
                if(res.code === 200){
                    this.userModelList = res.data.records
                    this.totalPages = res.data.total
                    this.currentElPage = res.data.current
                    // this.size = res.data.size
                }
            })
        },
        // 更新用户模型列表
        updateModelList(){
            let obj = {
                token: window.localStorage.getItem('userToken'),
                account: window.localStorage.getItem('userName'),
            }
            getUerModelList(obj).then(res=>{
                // console.log(res);
                if(res.code === '0'){
                    this.userModelLists = res.data.list
                    this.userModelList = this.userModelLists.slice(0, 5)
                    // 遍历给order
                    this.userModelLists.forEach((item,index)=>{
                        item.order = index+1
                    })
                } else {
                    this.$message.error(res.message)
                }
                // this.userModelList = res.data.list

            })
        },
        // 删除用户模型
        deleteModel(id){
            let token = window.localStorage.getItem('userToken')
            this.$confirm('此操作将永久删除该模型, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteUserModel(id, token).then(res => {
                    if(res.code === 200){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        })
                        this.getModelList()
                        this.currentElPage = 1
                    }
                }).catch(err=>{
                    this.$message.error(err.message)
            })
            }). catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            })
        },
        // 分享
        shareModel(model){
            if(model.isPublic){
                // 公开模型传id
                this.createUrl(null, model.id)
            }else{
                // 私有模型传key
                let token = window.localStorage.getItem('userToken')
                let obj = {
                    "isShare": true
                }
                createPrivateModelCode(model.id, token, obj).then(res=>{
                    if(res.code === 200){
                        let key = res.data
                        this.createUrl(key, null)
                        this.getModelList()
                    }
                })
            }
        },
        cancelShareModel(model){
            let token = window.localStorage.getItem('userToken')
            let obj = {
                "isShare": false
            }
            createPrivateModelCode(model.id, token, obj).then(res=>{
                if(res.code === 200){
                    this.$message.success('取消分享成功')
                    this.getModelList()
                }
            })
        },
        createUrl(key, id){
            // let url = 'http://localhost:8080/models_detail'
            let url = 'http://pongo.net.cn/models_detail'
            if(key) url += `?key=${key}`
            if(id) url += `?id=${id}`
            if (navigator.clipboard && window.isSecureContext) {
                // navigator clipboard 向剪贴板写文本
                navigator.clipboard.writeText(url).then(() => {
                    this.$message.success('已复制到剪切板')
                });
            } else {
                // 创建text area
                let textArea = document.createElement("textarea");
                textArea.value = url;
                // 使text area不在viewport，同时设置不可见
                textArea.style.position = "absolute";
                textArea.style.opacity = 0;
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                return new Promise((res, rej) => {
                    // 执行复制命令并移除文本框
                    document.execCommand('copy') ? res() : rej();
                    textArea.remove();
                    this.$message.success('已复制到剪切板')
                });
            }
        },
        editModel(model){
            this.$bus.$emit('close')
            this.$router.push({
                path:'/user/user_edit',
                query:{
                    id:model.id,
                }
            })
        },
        goModelDetail(obj){
            let token = window.localStorage.getItem('userToken')
            let id = obj.id
            getModelById(id, token)
            this.$router.push({
                path:'/models_detail',
                query:{
                    id:id,
                    name:obj.name,
                }
            })
        }
    },
    components: {
        ModelShowList
    },
    mounted() {
        this.getModelList()
        // let token = window.localStorage.getItem('userToken')
            
        // getUserModel(token).then(res=>{
        //     if (res.code === 200) {
        //         console.log(res);
        //         this.userModelList = res.data.records
        //         this.totalPages = res.data.total
        //         this.currentElPage = res.data.current
        //         this.size = res.data.size
        //     }
        //      else {
        //         this.$message.error(res.message)
        //     }
        // })
    }
}
</script>

<style scoped lang="less">
::v-deep .el-table td.el-table__cell div{
    display: flex;
    justify-content: center;
}
::v-deep .el-icon-delete-solid{
    color: #C9C9C9;
}
::v-deep .el-icon-delete-solid:hover{
    cursor: pointer;
    color: #54ceec;
}
::v-deep .el-table .cell{
    text-align: center;
}
// ::v-deep .el-pagination.is-background .btn-next, ::v-deep .el-pagination.is-background .btn-prev, ::v-deep .el-pagination.is-background .el-pager li{
//     // background-color: #8C8C8C;
//     color: #fff;
// }

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #54ceec;
    color: #fff;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover{
    color: #000;
}
// ::v-deep .el-table_12_column_66{
//     border-top-left-radius: 0.56rem;
//     border-bottom-left-radius: 0.56rem;
//     padding-left: 2rem !important;
// }

// ::v-deep .el-table_12_column_72{
//     border-top-right-radius: 0.56rem;
//     border-bottom-right-radius: 0.56rem;
// }

::v-deep .el-table .deep{
    background-color: #F9F9F9;
    border-radius: 10px;
}
::v-deep .el-table .shallow{
    background-color: #f4f4f4;
    border-radius: 10px;
}

::v-deep .el-table__header-wrapper,
::v-deep .el-table__body-wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 94%;
    margin: 0 auto;
}
::v-deep .el-table__header{
    width: auto !important;
}
::v-deep .el-table__body{
    width: auto !important;
  //-webkit-border-horizontal-spacing: 13px;  // 水平间距
  -webkit-border-vertical-spacing: 6px;  // 垂直间距
}
::v-deep .el-table::before{
    display: none;
}
::v-deep .el-table th.el-table__cell{
    background-color: #C9C9C9;
}
::v-deep .el-table_1_column_1{
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    padding-left: 2rem !important;
}
::v-deep .el-table_1_column_7{
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}
::v-deep .el-table th.el-table__cell>.cell{
    font-size: 0.85rem;
    font-weight: normal;
    color: #666666;
}
.my_model{
    // background-color: rgb(255, 255, 255);
    border-radius: 0.56rem;
    .model_container{
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 2.69rem 0;
        overflow: hidden;
        // height: 90px;
        i{
            font-size: 1.5rem;
            cursor: pointer;
        }
        i:hover{
            color: #54d1ef;
        }
        .title{
            background-color: aqua;
            width: 90%;
            height: 100%;
            margin: 0 auto;
        }
    }
    .model_page{
        // margin: 0 auto;
        display: flex;
        justify-content: center;
        padding: 2rem 0;
        // background-color: #54d1ef;
    }
}
</style>